import { styled, Box, Modal, Typography } from '@mui/material';
import { drawerWidth } from 'components/app-container/styles';
import { UPInputLabel } from 'components/input/styles';

export const ModalWrapper = styled(Modal)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '944px',
  maxHeight: '650px',
  height: '650px',
  '.MuiBackdrop-root': {
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    position: 'relative',
  },

  [theme.breakpoints.down(1000)]: {
    width: '97%',
    maxHeight: '534px',
    height: '70%',
  },
}));

export const InviteEmployeeModalWrapper = styled(Modal)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  // Centred on the content area rather than on the viewport. The modal is portalled to <body>,
  // so a plain `left: 50%` centres it against the full window and reads as pushed left, because
  // the permanent drawer covers the leftmost `drawerWidth`. Shifting by half the drawer moves
  // the centre to the middle of what the user can actually see.
  left: `calc(50% + ${drawerWidth / 2}px)`,
  transform: 'translate(-50%, -50%)',
  // Wider than the 944px the form tabs were drawn at, because the active-links tab holds a
  // table: at 944px (of which ModalContainer takes 90%, less the section's 32px padding) the
  // columns did not fit and the tab scrolled horizontally inside a vertically scrolling modal.
  //
  // The subtrahend is the drawer plus a 24px margin on each side of the content area, so the
  // box stays inside that area at every width instead of sliding under the drawer.
  width: `min(1120px, calc(100vw - ${drawerWidth + 48}px))`,
  // Keep the design height, but never exceed the viewport. The box is centred with a -50%
  // translate, so a plain 650px on a shorter window overflowed off both the top and bottom
  // edges — taking the tabs out of reach, since nothing here used to scroll.
  height: '650px',
  maxHeight: 'min(650px, 95vh)',
  '.MuiBackdrop-root': {
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    position: 'relative',
  },

  [theme.breakpoints.down(1000)]: {
    // No width override here: the `min()` above already narrows with the viewport, and the 97%
    // this used to set is a percentage of <body>, which — now that the box is offset to the
    // right of the drawer — pushed it off the right edge instead of fitting the content area.
    //
    // Hug the content up to a viewport-relative cap. The previous uncapped `height: 99%`
    // stretched the box to nearly the full viewport while the content stayed content-height,
    // which left dead space below the buttons. ModalContainer owns the scrolling, so capping
    // here no longer clips the footer.
    height: 'auto',
    maxHeight: '95vh',
  },
}));

export const ModalHeader = styled(Box)(() => ({
  position: 'sticky',
  top: 0,
  backgroundColor: 'white',
  padding: '32px 32px 0px 32px',
  zIndex: 999,
  borderTopRightRadius: '8px',
  borderTopLeftRadius: '8px',
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  width: '90%',
  // The card is narrower than the wrapper that centres it, and as a block element it would sit
  // flush left — leaving all of the leftover 10% on the right, which is what made a correctly
  // centred wrapper still look shifted towards the navigation drawer.
  margin: '0 auto',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
  background: 'rgb(250, 250, 250)',
  borderRadius: '8px',
  border: 'none',
  // The scroll container for the whole modal. Bounded explicitly rather than with height:100%,
  // because a percentage height against an auto-height parent is indefinite and would not
  // establish a scrollport. Without this, capping the wrapper clips the footer — the buttons
  // are last in flow, so they are the first thing to be cut off.
  maxHeight: 'min(650px, 95vh)',
  overflowY: 'auto',
  [theme.breakpoints.down(1000)]: {
    height: 'auto',
    width: '100%',
    maxHeight: '95vh',
  },
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  marginBottom: '16px',
  color: theme.palette.secondary.contrastText,
  fontWeight: 600,
  fontSize: 16,
  textAlign: 'left',
}));

export const ModalFooter = styled(Box)(() => ({
  backgroundColor: 'white',
  padding: '12px 0px',
  display: 'flex',
  justifyContent: 'center',
  borderBottomRightRadius: '8px',
  borderBottomLeftRadius: '8px',
}));

export const ErrorText = styled(UPInputLabel)(({ theme }) => ({
  '&.MuiFormLabel-colorPrimary': {
    color: theme.palette.error.main,
  },
}));

export const ModalCloseIcon = styled(Box)(() => ({
  position: 'absolute',
  right: 32,
  top: 32,
  width: 24,
  height: 24,
  cursor: 'pointer',
}));

export const RowContainerForContactInfo = styled(Box)(({ theme }) => ({
  display: 'flex',

  padding: '20px',
  marginTop: '0px',
  [theme.breakpoints.down(800)]: {
    flexDirection: 'column',
  },
}));

export const NameStyled = styled(Box)(({ theme }) => ({
  marginRight: '16px',
  width: '25%',
  [theme.breakpoints.down(800)]: {
    marginRight: 'unset',
    marginBottom: '16px',
    width: '100%',
  },
}));
export const EmailStyled = styled(Box)(({ theme }) => ({
  marginRight: '16px',
  width: '50%',
  [theme.breakpoints.down(800)]: {
    marginRignt: 'unset',
    width: '100%',
  },
}));

export const RowContainer = styled(Box)(({ theme }) => ({
  marginRight: '16px',
  width: '50%',
  [theme.breakpoints.down(800)]: {
    minWidth: '100%',
  },
}));
